<template>
  <div>
    <div class="player" :class="{ nexting: nextingTrack }">
      <div class="speaker-button" @click="togglePlay()">
        <div class="speaker-on" v-if="playerOn"></div>
        <div class="speaker-off" v-else></div>
      </div>
      <transition name="side-fade">
        <div class="next-button" v-if="playerOn" @click="nextTrack()"></div>
      </transition>
      <transition name="side-fade">
        <div class="forward-button" v-if="playerOn" @click="forward"></div>
      </transition>
    </div>
    <div class="soundCloud-player">
      <iframe
        id="ifrm"
        width="100"
        height="100"
        scrolling="no"
        frameborder="no"
        allow="autoplay"
        @load="initSC"
        src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/1149444292%3Fsecret_token%3Ds-LpZbnBZuIKK&color=%230414a7&auto_play=true&hide_related=false&show_comments=false&show_user=false&show_reposts=false&show_teaser=false"
      ></iframe>
      <div
        style="font-size: 10px; color: #cccccc;line-break: anywhere;word-break: normal;overflow: hidden;white-space: nowrap;text-overflow: ellipsis; font-family: Interstate,Lucida Grande,Lucida Sans Unicode,Lucida Sans,Garuda,Verdana,Tahoma,sans-serif;font-weight: 100;"
      >
        <a
          href="https://soundcloud.com/northernharlem"
          title="softly"
          target="_blank"
          style="color: #cccccc; text-decoration: none;"
          >softly</a
        >
        ·
        <a
          href="https://soundcloud.com/northernharlem/sets/spaceship/s-LpZbnBZuIKK"
          title="spaceship"
          target="_blank"
          style="color: #cccccc; text-decoration: none;"
          >spaceship</a
        >
      </div>
    </div>
  </div>
</template>

<script>
import { SC } from "@/plugins/soundcloud.js";
export default {
  name: "Player",
  data() {
    return {
      playerOn: false,
      widget: null,
      numberOfTracks: 0,
      nextingTrack: false,
    };
  },
  mounted() {},
  methods: {
    togglePlay() {
      this.widget.toggle();
    },
    initSC() {
      var iframeElement = document.getElementById("ifrm");
      var iframeElementID = iframeElement.id;
      /*eslint-disable*/
      this.widget = SC.Widget(iframeElementID);
      this.widget.bind(SC.Widget.Events.READY, () => {
        this.widget.getSounds((res) => {
          this.bindingPlayerEvents();
          this.numberOfTracks = res.length;
          this.nextTrack();
          const randDelay = Math.floor(Math.random() * 10000) + 10000;

          //setTimeout(() => this.announceTrack(), randDelay);
        });
      });
    },
    bindingPlayerEvents() {
      this.widget.bind(SC.Widget.Events.PLAY, () => {
        this.playerOn = true;
        if (this.nextingTrack) this.nextingTrack = false;
      });

      this.widget.bind(SC.Widget.Events.PAUSE, () => {
        this.playerOn = false;
      });
    },
    nextTrack() {
      if (!this.nextingTrack) {
        this.nextingTrack = true;
        let rand = Math.floor(Math.random() * this.numberOfTracks);
        let current;
        this.widget.getCurrentSoundIndex((res) => {
          if (this.$store.getters.devMode) console.log("current", res);
          current = res;
          if (rand == current) {
            while (rand == current) {
              rand = Math.floor(Math.random() * this.numberOfTracks);
            }
          }
          if (this.$store.getters.devMode)
            console.log(
              "Main console skipping from track " +
                current +
                " to track " +
                rand +
                " of " +
                this.numberOfTracks
            );

          this.widget.skip(rand);
        });
      }
    },
    announceTrack() {
      const randDelay = Math.floor(Math.random() * 25000) + 10000;
      this.widget.getCurrentSound((res) => {
        const newMsg = {
          text: "You are now listening to " + res.title,
          delay: 5000,
        };

        this.$store.commit("setWanerMsg", newMsg);
        setTimeout(() => this.announceTrack(), randDelay);
      });
    },
    forward() {
      this.widget.getPosition((res) => {
        this.widget.seekTo(res + 60000);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.soundCloud-player {
  position: absolute;
  top: -100vh;
  z-index: 0;
}

.nexting {
  opacity: 0.5;
}

.player {
  position: fixed;
  top: 2vh;
  left: 1vw;
  min-height: 10vh;
  display: flex;
  z-index: 5;
  transition: all 0.2s ease-in-out;
}

.player div {
  padding: 2px;
  vertical-align: middle;
}

.speaker-button {
  min-height: 100%;
  width: 4vw;
}

.speaker-on {
  background-image: url("../../assets/medias/images/speaker_on.png");
  background-size: 75%;
  background-repeat: no-repeat;
  height: 100%;
}

.speaker-off {
  background-image: url("../../assets/medias/images/speaker_off.png");
  background-size: 75%;
  background-repeat: no-repeat;
  height: 100%;
}

.next-button {
  background-image: url("../../assets/medias/images/next-button.png");
  background-size: 75%;
  background-repeat: no-repeat;
  min-height: 100%;
  width: 4vw;
}
.forward-button {
  background-image: url("../../assets/medias/images/forward-button.png");
  background-size: 75%;
  background-repeat: no-repeat;
  min-height: 120%;
  width: 4vw;
}
</style>
